<!-- Footer -->
<footer id="page-footer" class="opacity-0">
  <div class="content py-20 font-size-xs clearfix">
      <div class="float-right">
          Focus CRM<!--<i class="fa fa-heart text-pulse"></i> by <a class="font-w600" href="http://goo.gl/vNS3I" target="_blank">pixelcave</a>-->
      </div>
      <div class="float-left">
          <a class="font-w600" href="http://www.blueboxcfg.com" target="_blank">Focus CRM</a> &copy; <span class="js-year-copy"></span>
      </div>
  </div>
</footer>
<!-- END Footer -->


// WEBPACK FOOTER //
// ./client/app/core/layout/secure/footer/footer.component.html